import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  fetchEmailsList,
  fetchEmailDetailsById,
  updateEmail,
} from "../../apis/outlookService";

import type { RootState } from "../store"; // Import RootState

export const fetchEmails = createAsyncThunk(
  "emails/fetchList",
  async (
    params: { folderId: string; top?: number; filter?: string },
    { rejectWithValue }
  ) => {
    try {
      const emails = await fetchEmailsList({
        folderId: params.folderId,
        top: params.top || 50,
        filter: params.filter,
      });
      return emails;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch emails"
      );
    }
  }
);

export const fetchEmailById = createAsyncThunk(
  "emails/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const emailDetails = await fetchEmailDetailsById(id);
      return emailDetails;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch email details"
      );
    }
  }
);

// --- NEW THUNK ---
export const toggleEmailFlag = createAsyncThunk(
  "emails/toggleFlag",
  async (emailId: string, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const email = state.emails.selectedEmailDetails;

      if (!email || email.id !== emailId) {
        throw new Error(
          "Cannot toggle flag: Email not selected or ID mismatch."
        );
      }

      // Assuming your backend has a `flagged` property to patch
      const updatedEmail = await updateEmail(emailId, {
        flagged: !email.flagged,
      });
      return updatedEmail;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to toggle flag");
    }
  }
);
